<template>

    <v-container fluid>
  
    <!-- 업로드 프로그레스 -->
    <comloading :isVisible="progress_dialog" :progress="progress_value" />

    <!-- 이미지 크롭 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog" @keydown.esc="cancel_crop" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="cancel_crop"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:500px;">

              <vue-cropper
                  ref="cropper_land"
                  :key="option.autoCropWidth + '_' + option.autoCropHeight"
                  :src="imgSrc"
                  :aspect-ratio="option.autoCropWidth/option.autoCropHeight"
                  />

            </div>
            
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="cancel_crop">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>    
      

      <v-row align="center" dense no-gutters>
        <v-col cols="3">
          <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
        </v-col>
        <v-spacer/>
        <v-col cols="3">
          <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
        <v-col cols="3">
          <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
        </v-col>      
      </v-row>

      <v-row justify="center" dense v-if="editedItem.COVER_INFO != null && editedItem.COVER_INFO != undefined">
        <v-col cols="12" md="10" align="end">
          <v-btn elevation="0" color="primary" width="100" @click="showsite">{{$t('pagesetinfo_col35')}}</v-btn>
          <v-btn elevation="0" color="primary" class="ml-1" width="100" @click="save">{{$t('pagesetinfo_col36')}}</v-btn>
        </v-col>
      </v-row>

      <v-row justify="center" dense v-if="editedItem.COVER_INFO != null && editedItem.COVER_INFO != undefined">
        <v-col cols="12" md="10">

          <v-row justify="center" align="center" dense>
            <v-col cols="12" md="12">
              <div class="input_title w-100">{{$t('pagecoverinfo_col3')}}</div>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" style="height:140px;cursor:pointer;" no-gutters>
            <v-col cols="12" md="5" align="center" class="mr-10" align-self="center" style="height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
              @click="fileSelect('COVER_INFO.COVERLOGO', 430, 300)"
              >
              <div
                style="position:absolute; left:8px; top:8px;"
                >
                {{ $t('eventlist_label45')  }}
              </div>
              <img 
                height="120"
                :src="getNestedProperty(previewImg, 'COVER_INFO.COVERLOGO')"
                class="image" style="cursor:pointer"
                />
                <!-- @click="showImage(previewImg, 'COVER_INFO.COVERLOGO')" -->
              <v-icon 
                style="position:absolute; bottom:8px; right:8px;"
                >
                mdi-pencil
              </v-icon>
            </v-col>

            <v-col cols="12" md="5" align="center" align-self="center" style="height:120px;background:#eaeaea;position:relative;display:flex; align-items:center; justify-content:center;"
              @click="fileSelect('COVER_INFO.COVERLOGO_ENG', 430, 300)"
              >
              <div
                style="position:absolute; left:8px; top:8px;"
                >
                {{ $t('eventlist_label46')  }}
              </div>
              <img 
                height="120"
                :src="getNestedProperty(previewImg, 'COVER_INFO.COVERLOGO_ENG')"
                class="image" style="cursor:pointer"
                />
              <v-icon 
                style="position:absolute; bottom:8px; right:8px;"
                >
                mdi-pencil
              </v-icon>
            </v-col>

          </v-row>            
        
          <div class="d-flex flex-row">
            <label class="input_title" style="width:300px !important">{{$t('pagecoverinfo_col28')}}</label>
            <v-checkbox dense v-model="editedItem.COVER_INFO.BG_EFFECT" class="ml-5 mt-1"/>
          </div>

          <div class="d-flex flex-row">
            <label class="input_title" style="width:300px !important">{{$t('pagecoverinfo_col52')}}</label>
            <v-checkbox dense v-model="editedItem.COVER_INFO.FIRST_TITLE" class="ml-5 mt-1"/>
          </div>
      
          <div class="d-flex flex-row">
            <div class="input_title_noheight d-flex align-center justify-center">
              <span style="color:red;">*</span>{{$t('pagecoverinfo_col4')}}
            </div>
            <div class="f-flex w-100 mr-3">
              <input
                v-model="editedItem.COVER_INFO.EVENTNAME" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagecoverinfo_col4')"
                />
              <input
                v-model="editedItem.COVER_INFO.EVENTNAME_ENG" 
                class="input_input mt-1" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagecoverinfo_col5')"
                />
            </div>
            <dialogcolor 
              dense :title="$t('pagecoverinfo_col4')" class="ml-1" style="width:30px"
              :color="editedItem.COVER_INFO.EVENTNAME_FONT.COLOR" 
              path="COVER_INFO.EVENTNAME_FONT.COLOR" :obj="editedItem"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagecoverinfo_col4')" class="ml-1" style="width:30px"
              :size="editedItem.COVER_INFO.EVENTNAME_FONT.PCSIZE" 
              path="COVER_INFO.EVENTNAME_FONT.PCSIZE" :obj="editedItem"
              @callback="callback_value"
              />     
            <dialogfontsize2 
              dense :title="$t('pagecoverinfo_col4')" class="ml-1" style="width:30px"
              :size="editedItem.COVER_INFO.EVENTNAME_FONT.MBSIZE" 
              path="COVER_INFO.EVENTNAME_FONT.MBSIZE" :obj="editedItem"
              @callback="callback_value"
              />     
            <dialoglineheight 
              dense :title="$t('pagecoverinfo_col4')" class="ml-1" style="width:30px"
              :size="editedItem.COVER_INFO.EVENTNAME_FONT.LINEHEIGHT" 
              path="COVER_INFO.EVENTNAME_FONT.LINEHEIGHT" :obj="editedItem"
              @callback="callback_value"
              />     
            <dialogfontalign                               
              dense style="width:30px;display: none"
              :align="editedItem.COVER_INFO.EVENTNAME_FONT.ALIGN" 
              path="COVER_INFO.EVENTNAME_FONT.ALIGN" :obj="editedItem"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="editedItem.COVER_INFO.EVENTNAME_FONT" 
              @callback="callback_fontvalue"
              />                
          </div>

          <div class="d-flex flex-row mt-2">
            <div class="input_title_noheight d-flex align-center justify-center">{{$t('pagecoverinfo_col6')}}</div>
            <div class="f-flex w-100 mr-3">
              <input
                v-model="editedItem.COVER_INFO.EVENTSUBNAME" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagecoverinfo_col6')" 
                />
              <input
                v-model="editedItem.COVER_INFO.EVENTSUBNAME_ENG" 
                class="input_input mt-1" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagecoverinfo_col7')" 
                />
            </div>
              
            <dialogcolor 
              dense :title="$t('pagecoverinfo_col6')" class="ml-1" style="width:30px;"
              :color="editedItem.COVER_INFO.EVENTSUBNAME_FONT.COLOR" 
              path="COVER_INFO.EVENTSUBNAME_FONT.COLOR" :obj="editedItem"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagecoverinfo_col6')" class="ml-1" style="width:30px;"
              :size="editedItem.COVER_INFO.EVENTSUBNAME_FONT.PCSIZE" 
              path="COVER_INFO.EVENTSUBNAME_FONT.PCSIZE" :obj="editedItem"
              @callback="callback_value"
              />     
            <dialogfontsize2 
              dense :title="$t('pagecoverinfo_col6')" class="ml-1" style="width:30px;"
              :size="editedItem.COVER_INFO.EVENTSUBNAME_FONT.MBSIZE" 
              path="COVER_INFO.EVENTSUBNAME_FONT.MBSIZE" :obj="editedItem"
              @callback="callback_value"
              />     
            <dialoglineheight 
              dense :title="$t('pagecoverinfo_col6')" class="ml-1" style="width:30px;"
              :size="editedItem.COVER_INFO.EVENTSUBNAME_FONT.LINEHEIGHT" 
              path="COVER_INFO.EVENTSUBNAME_FONT.LINEHEIGHT" :obj="editedItem"
              @callback="callback_value"
              />     
            <dialogfontalign                               
              dense style="width:30px;;display: none"
              :align="editedItem.COVER_INFO.EVENTSUBNAME_FONT.ALIGN" 
              path="COVER_INFO.EVENTSUBNAME_FONT.ALIGN" :obj="editedItem"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="editedItem.COVER_INFO.EVENTSUBNAME_FONT" 
              @callback="callback_fontvalue"
              />        
                
          </div>                       

          <div class="d-flex flex-row mt-2">
            <div class="input_title_noheight d-flex align-center justify-center">
              <span style="color:red;">*</span><div v-html="$t('pagecoverinfo_col8')"></div>
            </div>
            <div class="f-flex w-100 mr-3">
              <input
                v-model="editedItem.COVER_INFO.COVERNAME" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagecoverinfo_col35')"
                />
              <input
                v-model="editedItem.COVER_INFO.COVERNAME_ENG" 
                class="input_input mt-1" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagecoverinfo_col9')"
                />
            </div>
            <dialogcolor 
              dense :title="$t('pagecoverinfo_col35')" class="ml-1" style="width:30px"
              :color="editedItem.COVER_INFO.COVERNAME_FONT.COLOR" 
              path="COVER_INFO.COVERNAME_FONT.COLOR" :obj="editedItem"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagecoverinfo_col35')" class="ml-1" style="width:30px"
              :size="editedItem.COVER_INFO.COVERNAME_FONT.PCSIZE" 
              path="COVER_INFO.COVERNAME_FONT.PCSIZE" :obj="editedItem"
              @callback="callback_value"
              />                
            <dialogfontsize2
              dense :title="$t('pagecoverinfo_col35')" class="ml-1" style="width:30px"
              :size="editedItem.COVER_INFO.COVERNAME_FONT.MBSIZE" 
              path="COVER_INFO.COVERNAME_FONT.MBSIZE" :obj="editedItem"
              @callback="callback_value"
              />                
            <dialoglineheight
              dense :title="$t('pagecoverinfo_col35')" class="ml-1" style="width:30px"
              :size="editedItem.COVER_INFO.COVERNAME_FONT.LINEHEIGHT" 
              path="COVER_INFO.COVERNAME_FONT.LINEHEIGHT" :obj="editedItem"
              @callback="callback_value"
              />                
            <dialogfontalign                               
              dense style="width:30px;display: none"
              :align="editedItem.COVER_INFO.COVERNAME_FONT.ALIGN" 
              path="COVER_INFO.COVERNAME_FONT.ALIGN" :obj="editedItem"
              @callback="callback_value"
              />
            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="editedItem.COVER_INFO.COVERNAME_FONT" 
              @callback="callback_fontvalue"
              />                
          </div>

          <div class="d-flex flex-row mt-2">
            <div class="input_title">{{$t('pagecoverinfo_col10')}}</div>
            <v-spacer/>
            <dialogcolor 
              dense :title="$t('pagecoverinfo_col10')" class="ml-1" style="width:30px"
              :color="editedItem.COVER_INFO.COVERDESC_FONT.COLOR" 
              path="COVER_INFO.COVERDESC_FONT.COLOR" :obj="editedItem"
              @callback="callback_value"
              />
            <dialogfontsize 
              dense :title="$t('pagecoverinfo_col10')" class="ml-1" style="width:30px"
              :size="editedItem.COVER_INFO.COVERDESC_FONT.PCSIZE" 
              path="COVER_INFO.COVERDESC_FONT.PCSIZE" :obj="editedItem"
              @callback="callback_value"
              />
            <dialogfontsize2 
              dense :title="$t('pagecoverinfo_col10')" class="ml-1" style="width:30px"
              :size="editedItem.COVER_INFO.COVERDESC_FONT.MBSIZE" 
              path="COVER_INFO.COVERDESC_FONT.MBSIZE" :obj="editedItem"
              @callback="callback_value"
              />
            <dialoglineheight 
              dense :title="$t('pagecoverinfo_col10')" class="ml-1" style="width:30px"
              :size="editedItem.COVER_INFO.COVERDESC_FONT.LINEHEIGHT" 
              path="COVER_INFO.COVERDESC_FONT.LINEHEIGHT" :obj="editedItem"
              @callback="callback_value"
              />
            <dialogfontalign                               
              dense style="width:30px;display: none"
              :align="editedItem.COVER_INFO.COVERDESC_FONT.ALIGN" 
              path="COVER_INFO.COVERDESC_FONT.ALIGN" :obj="editedItem"
              @callback="callback_value"
              />

            <dialogfont class="ml-1" style="width:400px"
              :comidx="SEARCH_COM_IDX" 
              :font="editedItem.COVER_INFO.COVERDESC_FONT" 
              @callback="callback_fontvalue"
              />                
          </div>
          <v-textarea
            v-model="editedItem.COVER_INFO.COVERDESC" 
            outlined rows="3" class="mt-1"
            style="white-space:pre-line;width:100%"
            :placeholder="$t('pagecoverinfo_col10')"
            dense single-line hide-details
            />
          <v-textarea
            v-model="editedItem.COVER_INFO.COVERDESC_ENG" 
            outlined rows="3" class="mt-1"
            style="white-space:pre-line;width:100%"
            :placeholder="$t('pagecoverinfo_col11')"
            dense single-line hide-details
            />



        <div class="d-flex flex-row mt-2">
          <div class="input_title" style="width:250px !important">{{$t('pagecoverinfo_col53')}}</div>
          <v-spacer/>
                      
        </div>
        <v-textarea
          v-model="editedItem.COVER_INFO.MOBILEDESC" 
          outlined rows="3" class="mt-1"
          style="white-space:pre-line;width:100%"
          :placeholder="$t('pagecoverinfo_col53')"
          dense single-line hide-details
          />
        <v-textarea
          v-model="editedItem.COVER_INFO.MOBILEDESC_ENG" 
          outlined rows="3" class="mt-1"
          style="white-space:pre-line;width:100%"
          :placeholder="$t('pagecoverinfo_col54')"
          dense single-line hide-details
          />            

            <div class="d-flex flex-row mt-2">
              <div class="input_title_noheight d-flex align-center justify-center">{{$t('pagecoverinfo_col12')}}</div>
              <div class="f-flex w-100 mr-3">
                <input
                  v-model="editedItem.COVER_INFO.COFIRMNAME" 
                  class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                  :placeholder="$t('pagecoverinfo_col36')"
                  />
                <input
                  v-model="editedItem.COVER_INFO.COFIRMNAME_ENG" 
                  class="input_input mt-1" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                  :placeholder="`${$t('pagecoverinfo_col36')}(ENG)`"
                  />
              </div>
              <dialogcolor 
                dense :title="$t('pagesetinfo_col9')" class="ml-1" style="width:30px"
                :color="editedItem.COVER_INFO.COFIRMNAME_FONT.COLOR" 
                path="COVER_INFO.COFIRMNAME_FONT.COLOR" :obj="editedItem"
                @callback="callback_value"
                />
              <dialogfontsize 
                dense :title="$t('pagecoverinfo_col12')" class="ml-1" style="width:30px"
                :size="editedItem.COVER_INFO.COFIRMNAME_FONT.PCSIZE" 
                path="COVER_INFO.COFIRMNAME_FONT.PCSIZE" :obj="editedItem"
                @callback="callback_value"
                />
              <dialogfontsize2 
                dense :title="$t('pagecoverinfo_col12')" class="ml-1" style="width:30px"
                :size="editedItem.COVER_INFO.COFIRMNAME_FONT.MBSIZE" 
                path="COVER_INFO.COFIRMNAME_FONT.MBSIZE" :obj="editedItem"
                @callback="callback_value"
                />
              <dialoglineheight
                dense :title="$t('pagecoverinfo_col12')" class="ml-1" style="width:30px"
                :size="editedItem.COVER_INFO.COFIRMNAME_FONT.LINEHEIGHT" 
                path="COVER_INFO.COFIRMNAME_FONT.LINEHEIGHT" :obj="editedItem"
                @callback="callback_value"
                />
              <dialogfontalign                               
                dense style="width:30px;display: none"
                :align="editedItem.COVER_INFO.COFIRMNAME_FONT.ALIGN" 
                path="COVER_INFO.COFIRMNAME_FONT.ALIGN" :obj="editedItem"
                @callback="callback_value"
                />
              <dialogfont class="ml-1" style="width:400px"
                :comidx="SEARCH_COM_IDX" 
                :font="editedItem.COVER_INFO.COFIRMNAME_FONT" 
                @callback="callback_fontvalue"
                />                
            </div>

            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagecoverinfo_col16')}}</div>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col40')" class="ml-3" style="width:30px;"
                :color="editedItem.COVER_INFO.CHECKBTN_TEXT_COLOR" 
                path="COVER_INFO.CHECKBTN_TEXT_COLOR" :obj="editedItem"
                @callback="callback_value"
                />
              <input
                v-model="editedItem.COVER_INFO.CHECKBTN" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagecoverinfo_col37')"
                />
              <input
                v-model="editedItem.COVER_INFO.CHECKBTN_ENG" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="`${$t('pagecoverinfo_col37')}(ENG)`"
                />
            </div>
            <div class="d-flex flex-row mt-2">
              <div class="input_title">{{$t('pagecoverinfo_col17')}}</div>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col40')" class="ml-3" style="width:30px;"
                :color="editedItem.COVER_INFO.CONFIRMBTN_TEXT_COLOR" 
                path="COVER_INFO.CONFIRMBTN_TEXT_COLOR" :obj="editedItem"
                @callback="callback_value"
                />
              <input
                v-model="editedItem.COVER_INFO.CONFIRMBTN" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="$t('pagecoverinfo_col38')"
                />
              <input
                v-model="editedItem.COVER_INFO.CONFIRMBTN_ENG" 
                class="input_input" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
                :placeholder="`${$t('pagecoverinfo_col38')}(ENG)`"
                />
            </div>

            <div class="d-flex flex-row mt-2">
              <label class="input_title">{{$t('pagecoverinfo_col14')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col14')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.BG_COLOR" 
                path="COVER_INFO.BG_COLOR" :obj="editedItem"
                @callback="callback_value"
                />
            </div>

            <div class="d-flex flex-row mt-2">
              <label class="input_title">{{$t('pagecoverinfo_col18')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col18')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.BGROUND_COLOR" 
                path="COVER_INFO.BGROUND_COLOR" :obj="editedItem"
                @callback="callback_value"
                />
            </div>

            <div class="d-flex flex-row mt-2">
              <label class="input_title">{{$t('pagecoverinfo_col15')}}</label>

              <dialogcolor 
                dense :title="$t('pagecoverinfo_col15')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.BTN_COLOR" 
                path="COVER_INFO.BTN_COLOR" :obj="editedItem"
                @callback="callback_value"
                />

              <label class="input_title ml-5">{{$t('pagecoverinfo_col43')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col43')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.BTN2_COLOR" 
                path="COVER_INFO.BTN2_COLOR" :obj="editedItem"
                @callback="callback_value"
                />
              </div>

            
            <div class="d-flex flex-row mt-2">

              <label class="input_title">{{$t('pagecoverinfo_col48')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col39')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.TITLE_COLOR" 
                path="COVER_INFO.TITLE_COLOR" :obj="editedItem"
                @callback="callback_value"
                />

              <label class="input_title ml-5">{{$t('pagecoverinfo_col39')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col39')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.REQ_COLOR" 
                path="COVER_INFO.REQ_COLOR" :obj="editedItem"
                @callback="callback_value"
                />

              <label class="input_title ml-5">{{$t('pagecoverinfo_col40')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col40')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.TEXT_COLOR" 
                path="COVER_INFO.TEXT_COLOR" :obj="editedItem"
                @callback="callback_value"
                />

              <label class="input_title ml-5">{{$t('pagecoverinfo_col41')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col41')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.DESC_COLOR" 
                path="COVER_INFO.DESC_COLOR" :obj="editedItem"
                @callback="callback_value"
                />

              <label class="input_title ml-5">{{$t('pagecoverinfo_col47')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col47')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.HINT_COLOR" 
                path="COVER_INFO.HINT_COLOR" :obj="editedItem"
                @callback="callback_value"
                />
            </div>

            <div class="d-flex flex-row mt-2">

              <label class="input_title">{{$t('pagecoverinfo_col42')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col41')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.TEXTBG_COLOR" 
                path="COVER_INFO.TEXTBG_COLOR" :obj="editedItem"
                @callback="callback_value"
                />

              <label class="input_title ml-5">{{$t('pagecoverinfo_col44')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col44')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.TEXTLINE_COLOR" 
                path="COVER_INFO.TEXTLINE_COLOR" :obj="editedItem"
                @callback="callback_value"
                />

              <label class="input_title ml-5">{{$t('pagecoverinfo_col45')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col45')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.FOCUS_COLOR" 
                path="COVER_INFO.FOCUS_COLOR" :obj="editedItem"
                @callback="callback_value"
                />

              <label class="input_title ml-5">{{$t('pagecoverinfo_col46')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col46')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.FOCUSLINE_COLOR" 
                path="COVER_INFO.FOCUSLINE_COLOR" :obj="editedItem"
                @callback="callback_value"
                />
                          
            </div>

            <div class="d-flex flex-row mt-2">
              <label class="input_title" style="width:300px !important">{{$t('pagecoverinfo_col55')}}</label>
              <v-checkbox dense v-model="editedItem.COVER_INFO.TOP_COLOR_AUTO" class="ml-5 mt-1" @change="change_topcolorauto"/>
            </div>

            <div class="d-flex flex-row" v-if="editedItem.COVER_INFO.TOP_COLOR_AUTO" style="font-size:13px;color:#777777">
              {{$t('pagecoverinfo_col56')}}
            </div>

            <div class="d-flex flex-row mt-2" v-else>

              <label class="input_title">{{$t('pagecoverinfo_col49')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col49')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.TOP_TEXT1_COLOR" 
                path="COVER_INFO.TOP_TEXT1_COLOR" :obj="editedItem"
                @callback="callback_value"
                />

              <label class="input_title ml-5">{{$t('pagecoverinfo_col50')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col50')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.TOP_TEXT2_COLOR" 
                path="COVER_INFO.TOP_TEXT2_COLOR" :obj="editedItem"
                @callback="callback_value"
                />

              <label class="input_title ml-5">{{$t('pagecoverinfo_col51')}}</label>
              <dialogcolor 
                dense :title="$t('pagecoverinfo_col51')" class="ml-1" style="width:30px;"
                :color="editedItem.COVER_INFO.TOP_CLOSE_COLOR" 
                path="COVER_INFO.TOP_CLOSE_COLOR" :obj="editedItem"
                @callback="callback_value"
                />
                          
            </div>            

        </v-col>      
    </v-row>
  
  </v-container>
  </template>
  
  <script>
import VueCropper from 'vue-cropperjs'; //이미지 크롭
import 'cropperjs/dist/cropper.css';
//import { VueCropper } from 'vue-cropper'; //교체용 크롭 라이브러리
import cmvalidation from '../assets/js/cmvalidation.js'
import { isAutoTopColor, isDefaultTopColor, autoTopColors, fixColorHash } from '../assets/js/topcolor.js'

  export default {
      components:{
        VueCropper
      },
  
      data: () => ({

        progress_dialog : false,    //로딩 표시
        progress_value:0,

        //이미지 크롭
        crop_dialog: false,
        imgSrc:'',
        s3: null,   //aws

        uploadFile : [],
        photo_index: 0,
        previewImg:[],      //이미지 미리보기

        //신규 크롭 파라메터
        option: {
            img: "",
            outputSize: 1,
            outputType: "jpg",
            canMove: true,
            fixed: true,                  //크롭박스 비율 고정
            fixedNumber: [1920, 340],    //크롭박스 비율
            fixedBox: false,      //true면 크롭박스 크기 조절 안됨
            original: false,      //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
            canMoveBox: true,
            autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
            autoCropWidth:440,    //크롭박스의 가로 크기 fixed가 true면 비율대로
            autoCropHeight:300,   //크롭박스의 세로 크기 
            centerBox: true,
            high: false,
            cropData: {},
            enlarge: 1,
            mode: 'contain',
            maxImgSize: 5000,
            limitMinSize: [1000, 300]
        },

        //필수 페이징 파라메터
        totalcnt : 0,       //전체 아이템 개수
        page : 0,
        maxpage : 0,        //전체 페이지 개수
        startpage : 1,      //시작 인덱스
        bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
        subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
        loading : false,    //로딩 표시

        //CRUD 관련
        dialogTitle: '추가하기',   //다이얼로그 제목
        editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
        defaultItem: {

            COVER_INFO: {
              COVERLOGO: null
            , EVENTNAME:""
            , EVENTNAME_ENG:""
            , EVENTNAME_FONT:{
                NAME:"나눔고딕 ExtraBold"
              , CODE:"나눔고딕 ExtraBold"
              , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothicExtraBold.ttf"
              , PCSIZE: 24
              , MBSIZE: 24
              , LINEHEIGHT: 150
              , COLOR: "#FFFFFFFF"
              , ALIGN: "center"
            }
            , EVENTSUBNAME:""
            , EVENTSUBNAME_ENG:""
            , EVENTSUBNAME_FONT:{
                NAME:"나눔고딕"
              , CODE:"나눔고딕"
              , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
              , PCSIZE: 14
              , MBSIZE: 14
              , LINEHEIGHT: 150
              , COLOR: "#7f7f7fFF"
              , ALIGN: "center"
            }
            , COVERNAME:"참가자 등록"
            , COVERNAME_ENG:"Participant Registration"
            , COVERNAME_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 18
                , MBSIZE: 18
                , LINEHEIGHT: 150
                , COLOR: "#d7d7d7FF"
                , ALIGN: "center"
            }
            , COVERDESC:"FAIRPASS 회원은 입력된 정보로 간편하게 행사 등록을 하실 수 있습니다. 회원가입 하시면 다양한 행사 정보, 이벤트, 할인, 명함 교환 등 다양한 혜택을 받으실 수 있습니다."
            , COVERDESC_ENG:"FAIRPASS members can easily register for events using the provided information. By signing up, you can enjoy a variety of benefits including comprehensive event details, exclusive promotions, discounts, business card exchanges, and more."
            , COVERDESC_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 13
                , MBSIZE: 13
                , LINEHEIGHT: 150
                , COLOR: "#7f7f7fFF"
                , ALIGN: "center"
            }

            , MOBILEDESC:"행사장 입장을 위한 명찰 발급을 위해 QR 코드를 전송드리오니 휴대폰번호를 정확히 입력하여 주시기 바랍니다."
            , MOBILEDESC_ENG:"We are sending you a QR code to issue a name tag to enter the venue, so please enter your mobile phone number correctly."
            

            //등록확인 커버명
            , COFIRMNAME:"등록자 본인 확인"
            , COFIRMNAME_ENG:"Identity Verification"
            , COFIRMNAME_FONT:{
                  NAME:"나눔고딕"
                , CODE:"나눔고딕"
                , FONTURL:"https://blueorigin-mice-fonts.s3.ap-northeast-2.amazonaws.com/NanumGothic.ttf"
                , PCSIZE: 18
                , MBSIZE: 18
                , LINEHEIGHT: 150
                , COLOR: "#d7d7d7FF"
                , ALIGN: "center"
            }

            //버튼명명
            , CHECKBTN:"등록확인"
            , CONFIRMBTN:"등록신청"
            , CHECKBTN_ENG:"Status"
            , CONFIRMBTN_ENG:"Register"

            //배경색, 라운드색, 버튼색
            , BG_COLOR:"#000000ff"
            , BGROUND_COLOR:"#0F0F0FFF"
            , BTN_COLOR:"#3F55C9FF"
            , BG_EFFECT:1
            , FIRST_TITLE:1


            , CHECKBTN_TEXT_COLOR: "#FFFFFFFF"     //입장권 확인
            , CONFIRMBTN_TEXT_COLOR: "#FFFFFFFF"   //입장권 신청
            , BTN2_COLOR: "#3F55C9FF"

            , REQ_COLOR:"#627BFFFF"               //* 표시 색상
            , TITLE_COLOR:"#d0d2d1FF"               //질문색상
            , TEXT_COLOR:"#d7d7d7FF"              //텍스트 입력 색상
            , DESC_COLOR:"#FFFFFFFF"              //설명 색상
            , HINT_COLOR:"#76789BFF"              //힌트, 등록자 정보 색상

            , TEXTBG_COLOR:"#333333FF"            //입력창 배경 색상
            , TEXTLINE_COLOR:"#444444FF"          //입력창 라인 색상
            , FOCUS_COLOR:"#0F0F0FFF"             //입력창 포커스시 배경 색상
            , FOCUSLINE_COLOR:"#2E98E6FF"         //입력창 포커스시 라인 색상

            , TOP_COLOR_AUTO:true                 //상단 글자색(언어 선택, 탭, X버튼)을 배경 색상에 맞춰 자동으로
            , TOP_TEXT1_COLOR:"#FFFFFFFF"
            , TOP_TEXT2_COLOR:"#AAAAAAFF"
            , TOP_CLOSE_COLOR:"#7F7F7FFF"

          }
          
                 
        },
        editedItem: {},
        
        grade : 0,
        SEARCH_COM_IDX: null,
        SEARCH_COM_NAME: '',
        SEARCH_EVENT_IDX: null,
        SEARCH_EVENT_NAME: '',

      }),
  
      beforeMount(){
        //로드전에 객체화 (경고 메시지 안나오게)
        this.editedItem = Object.assign({}, this.defaultItem);
      },
  
      mounted(){

        if(this.$session.get("GRADE") < 10){
          this.$alert(this.$t("common_nograde"));
          this.$router.push("Login");
          return;
        }
  
        this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
        this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
        this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
        this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
        this.grade = this.$session.get("GRADE");
  
        if(this.$session.exists("ADMIN_IDX")){
          this.initpage();
        }else{
          //키값 없으면 로그인으로
          this.$router.push("Login");
        }
      },
  
      create(){
  
      },


      beforeDestroy(){
        //아이폰의 경우 찌거기 제거
        let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
        if(indexcnt > -1){
            let elements = document.getElementsByName("imageinputcamera");
            for(var i=0, len=elements.length ; i != len; ++i){
                elements[0].parentNode.removeChild(elements[0]);
            }
        }
        },      
  
      methods: {
  
        showsite(){
            window.open("https://fairpass.co.kr/RunEventInfo?eventcode="+this.SEARCH_EVENT_IDX, "_blank");
        },

        callback_fontvalue(value, obj){
          let target      = obj;
          target.NAME     = value.NAME;
          target.CODE     = value.CODE;
          target.FONTURL  = value.FONTURL;
          this.$forceUpdate();
        },

        //상단 글자색을 직접 지정으로 바꿀 때, 색을 바꾼 적이 없으면 지금 화면에 보이는 자동 색으로 채워서 시작
        change_topcolorauto(value){
          if(value) return;
          const cover = this.editedItem.COVER_INFO;
          if(!isDefaultTopColor(cover)) return;

          const auto = autoTopColors(cover.BG_COLOR);
          cover.TOP_TEXT1_COLOR = auto.SELECT + "FF";
          cover.TOP_TEXT2_COLOR = auto.UNSELECT + "FF";
          cover.TOP_CLOSE_COLOR = auto.CLOSE + "FF";
        },

        callback_value(value, path, obj){

          const keys = path.split('.');
          let target = obj;

          for (let i = 0; i < keys.length - 1; i++) {
            // 배열 인덱스 처리
            const key = keys[i].match(/^(\w+)\[(\d+)\]$/);
            if (key) {
              const arrayKey = key[1]; // 배열 이름
              const index = parseInt(key[2], 10); // 배열 인덱스

              // 배열이 없으면 생성
              if (!target[arrayKey]) {
                target[arrayKey] = [];
              }

              // 인덱스 위치에 객체가 없으면 생성
              if (!target[arrayKey][index]) {
                target[arrayKey][index] = {};
              }

              target = target[arrayKey][index];
            } else {
              // 일반 객체 처리
              if (!target[keys[i]]) {
                target[keys[i]] = {};
              }
              target = target[keys[i]];
            }
          }        

          // 마지막 키에 값 설정
          const lastKey = keys[keys.length - 1];
          const lastKeyMatch = lastKey.match(/^(\w+)\[(\d+)\]$/);
          if (lastKeyMatch) {
            const arrayKey = lastKeyMatch[1];
            const index = parseInt(lastKeyMatch[2], 10);

            if (!target[arrayKey]) {
              target[arrayKey] = [];
            }

            target[arrayKey][index] = value;
          } else {
            target[lastKey] = value;
          }        
        
          this.$forceUpdate();

        },        

        cancel_crop(){
            this.crop_dialog = false;
        },

        cropimg(){

          this.crop_dialog = false;
          this.$refs.cropper_land.getCroppedCanvas().toBlob((blob) => {
            this.setNestedProperty(this.uploadFile, this.photo_key, blob);
          });
          
          this.setNestedProperty(this.previewImg, this.photo_key, this.$refs.cropper_land.getCroppedCanvas().toDataURL("image/jpeg"));

        },              

        showImage(obj, path){

          const value = this.getNestedProperty(obj, path);

          if(!value){
              return;
          }
            
          this.$viewerApi({
              options: {
                  zIndex:9999
              },          
              images: [value]
          });

        },  

        fileSelect(key, width, height){

            const changefunction = this.selectfile;
            var input = document.createElement("input");
            input.style = "display:none";
            input.name = "imageinputcamera";
            input.type = "file";
            input.accept = ".jpg,.jpeg,.png"; // 확장자가 xxx, yyy 일때, ".xxx, .yyy"

            /* 크롭사이즈 변경 */
            if(width != null && height != null){
              this.option.autoCropWidth  = width;
              this.option.autoCropHeight = height;
              this.option.aspectRatio = width/height;
              this.option.fixed = true;
            }else{
              this.option.autoCropWidth  = NaN;
              this.option.autoCropHeight = NaN;
              this.option.aspectRatio = NaN;
              this.option.fixed = false;
            }

            let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
            if(indexcnt > -1){
                //아이폰, 아이패드, 맥
                //input이 실제 돔에 추가되야 사진수정에 따른 onchange가 작동한다.
                document.body.appendChild(input);
                input.onchange = function (event) {
                    document.body.removeChild(input);
                    changefunction(event.target.files[0], key);
                };
            }else{
                input.onchange = function (event) {
                    changefunction(event.target.files[0], key);
                };
            }
            input.click();
        },           

        //아이콘에서 파일 변경시
        selectfile(file, key){

            if(file.size/1024/1024 > 10){
                this.$alert(this.$t('eul_msg101'));
                this.setNestedProperty(this.uploadFile, key, null);
                //this.uploadFile[key] = null;
                return;
            }


            const reader = new FileReader();
            reader.onload = (event)=>{
                this.photo_key    = key;
                this.crop_dialog  = true;
                this.imgSrc       = event.target.result;  //이게 blob데이터
                this.$refs.cropper_land.replace(event.target.result);
            }
            reader.readAsDataURL(file);  //비동기로 파일을 읽어서

        },      

        /**
         * 이미지 업로드
         * @param {number} korname   - 업로드 구분값 (오류시 보여줌)
         * @param {number} imgparam  - 저장할 파일명 이름 
         * @param {number} uploadpath - uploadFile에 저장된 이미지의 path 
         * @param {number} savepath   - editedItem에 저장할 path 
         */        
        async checkimgupload(korname, imgparam, uploadpath, savepath){
            
          const s3obj     = this.$s3;
          const folder    = this.SEARCH_COM_IDX.toString();         //중간폴더명
          var albumPhotosKey = encodeURIComponent(folder) + "/";    //중간경로명  /게 붙어야 폴더됨.
          // s3에 폴더 생성
          // eslint-disable-next-line no-unused-vars
          await s3obj.putObject({Key: albumPhotosKey}, async (err2, data2) => {
              if(err2) {
                  //앨범생성 오류
                  this.$alert(this.$t('eventinfo_msg16'));
                  return false;
              }
          });   

          

          //파일이 지정된 경우
          const filevalue = this.getNestedProperty(this.uploadFile, uploadpath);
          if(filevalue){

              this.progress_dialog = true;            
              let imgpath;
              let curdate = Date.now().toString();    //무조건 신규 파일명으로 그래야 디자인 갱신됨.
              imgpath  = `${imgparam}_${curdate}.jpg`;
              
              var photoKey = albumPhotosKey + imgpath;                 //최종 경로

              

              const stored = await s3obj.upload({
                                                      Bucket: "blueorigin-mice-image",
                                                      Key: photoKey,
                                                      Body: filevalue,
                                                      ACL: "public-read"
                                                  }).promise();

              if(stored == null || stored.Location == null){

                

                  this.progress_dialog = false;
                  this.$fire({ 
                      html:`${this.$t('common_process_fail')} <br> ${korname}`
                  });
                  return false;
              }
              this.progress_dialog = false;
              
              this.setNestedProperty(this.uploadFile, uploadpath, null);
              
              this.setNestedProperty(this.editedItem, savepath, stored.Location);          //////////////////////
              
              return true;

          }else{
            //파일이 없어도 패스
            
            this.progress_dialog = false;
            return true;
          }

        },        

        //obj의 path에 값을 저장한다. path는 프로퍼티, 배열인덱스 가능
        setNestedProperty(obj, path, value) {

          const keys = path.split('.'); // 경로를 점(.)으로 분리
          let target = obj;

          for (let i = 0; i < keys.length - 1; i++) {

            // 배열 인덱스 처리
            const arrayMatch = keys[i].match(/^(\w+)\[(\d+)\]$/); // 배열 키 패턴: key[index]
            if (arrayMatch) {
              const arrayKey = arrayMatch[1]; // 배열 이름
              const index = parseInt(arrayMatch[2], 10); // 배열 인덱스

              // 배열이 없으면 생성
              if (!target[arrayKey]) {
                target[arrayKey] = [];
              }

              // 배열의 인덱스에 객체가 없으면 생성
              if (!target[arrayKey][index]) {
                target[arrayKey][index] = {};
              }

              target = target[arrayKey][index]; // 다음 단계로 이동
            } else {
              // 일반 객체 처리
              if (!target[keys[i]]) {
                target[keys[i]] = {}; // 키가 없으면 객체 생성
              }
              target = target[keys[i]]; // 다음 단계로 이동
            }
          }

          // 마지막 키에 값 설정
          const lastKey = keys[keys.length - 1];
          const lastArrayMatch = lastKey.match(/^(\w+)\[(\d+)\]$/);

          if (lastArrayMatch) {
            const arrayKey = lastArrayMatch[1];
            const index = parseInt(lastArrayMatch[2], 10);

            if (!target[arrayKey]) {
              target[arrayKey] = [];
            }

            target[arrayKey][index] = value;
          } else {
            target[lastKey] = value;
          }
        },

        //obj의 특정 path에서 값을 가져온다.
        getNestedProperty(obj, path) {
          
          const keys = path.split('.'); // 경로를 점(.)으로 분리
          let target = obj;

          for (let i = 0; i < keys.length; i++) {
            // 배열 인덱스 처리
            const arrayMatch = keys[i].match(/^(\w+)\[(\d+)\]$/); // 배열 키 패턴: key[index]
            if (arrayMatch) {
              const arrayKey = arrayMatch[1]; // 배열 이름
              const index = parseInt(arrayMatch[2], 10); // 배열 인덱스

              if (!target[arrayKey] || !Array.isArray(target[arrayKey]) || !target[arrayKey][index]) {
                return undefined; // 배열 또는 인덱스가 유효하지 않으면 undefined 반환
              }
              target = target[arrayKey][index];
            } else {
              // 일반 객체 처리
              if (!target[keys[i]]) {
                return undefined; // 키가 없으면 undefined 반환
              }
              target = target[keys[i]];
            }
          }

          return target; // 최종 값을 반환
        },


        loadpage(){

            this.editedItem = {};
            
            if(this.SEARCH_COM_IDX == null){
              this.$alert(this.$t('common_select_tcom'));
              return;
            }
            if(this.SEARCH_EVENT_IDX == undefined || this.SEARCH_EVENT_IDX == null){
              this.$alert(this.$t("common_select_event"));
              return;
            }

            this.progress_dialog = true;

            this.$http.post(this.$host+'/api/getPageInfo',{
                  ADMIN_IDX: this.$session.get("ADMIN_IDX")
                , COM_IDX: this.SEARCH_COM_IDX
                , EVENT_IDX: this.SEARCH_EVENT_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then((result)=>{
              this.progress_dialog = false;
              if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                    this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                    this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                if(result.data.resultData.length == 0){

                  //최초
                  this.editedItem = Object.assign({}, this.defaultItem);

                  this.editedItem.COVER_INFO.EVENTNAME     = result.data.eventData[0].NAME;
                  this.editedItem.COVER_INFO.EVENTNAME_ENG = result.data.eventData[0].NAME_ENG;


                }else{

                    //로드한 경우
                    this.editedItem.COVER_INFO = Object.assign({}, this.defaultItem.COVER_INFO);
                      
                    //this.editedItem.COVER_INFO = JSON.parse(JSON.stringify(result.data.resultData[0].COVER_INFO));
                    const temp = JSON.parse(JSON.stringify(result.data.resultData[0].COVER_INFO));
                    //상단 글자색 자동 여부가 없는 기존 행사는 참가자 화면과 같은 기준으로 정한다 (자동)
                    if(temp.TOP_COLOR_AUTO === undefined || temp.TOP_COLOR_AUTO === null){
                      temp.TOP_COLOR_AUTO = isAutoTopColor(temp);
                    }
                    //# 이 빠진 색 값(예전 등록확인·등록신청 글자색 기본값 "FFFFFFFF")은 # 을 붙인다
                    fixColorHash(temp);
                    this.editedItem.COVER_INFO = { ...this.defaultItem.COVER_INFO, ...temp }; //양식이 변경된 경우대비

                    this.setNestedProperty(this.previewImg, "COVER_INFO.COVERLOGO", this.editedItem.COVER_INFO.COVERLOGO);
                    this.setNestedProperty(this.previewImg, "COVER_INFO.COVERLOGO_ENG", this.editedItem.COVER_INFO.COVERLOGO_ENG);


                }
  
              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.progress_dialog = false;
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동
  
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              
              this.progress_dialog = false;
              if(error.message == 'Request failed with status code 429')
              {
                this.$alert(this.$t("common_reqer"));
              }else{
                this.$alert(error.message);
              }
            });
  
        },
  
        initpage(){

            //첫페이지 로드
            this.loadpage();

        },      
  
        //검색
        search_run(){
          this.loadpage();
        },




        //추가 저장
        async save () {

          
          const eventName = cmvalidation.checkValReg(this.editedItem.COVER_INFO.EVENTNAME, null, -1, -1);
          if(eventName == 1){
            this.$alert(this.$t('pagecoverinfo_col20'));
            return;
          }
          const subName = cmvalidation.checkValReg(this.editedItem.COVER_INFO.EVENTSUBNAME, null, -1, -1);
          if(subName == 1){
            this.$alert(this.$t('pagecoverinfo_col21'));
            return;
          }
          const coverName = cmvalidation.checkValReg(this.editedItem.COVER_INFO.COVERNAME, null, -1, -1);
          if(coverName == 1){
            this.$alert(this.$t('pagecoverinfo_col22'));
            return;
          }
          const descName = cmvalidation.checkValReg(this.editedItem.COVER_INFO.COVERDESC, null, -1, -1);
          if(descName == 1){
            this.$alert(this.$t('pagecoverinfo_col23'));
            return;
          }
          const confirmName = cmvalidation.checkValReg(this.editedItem.COVER_INFO.COFIRMNAME, null, -1, -1);
          if(confirmName == 1){
            this.$alert(this.$t('pagecoverinfo_col24'));
            return;
          }
          const checkName = cmvalidation.checkValReg(this.editedItem.COVER_INFO.CHECKBTN, null, -1, -1);
          if(checkName == 1){
            this.$alert(this.$t('pagecoverinfo_col25'));
            return;
          }
          const confirmbtn = cmvalidation.checkValReg(this.editedItem.COVER_INFO.CONFIRMBTN, null, -1, -1);
          if(confirmbtn == 1){
            this.$alert(this.$t('pagecoverinfo_col26'));
            return;
          }
          
          const imgflag = await this.checkimgupload(this.$t('pagesetinfo_col37'), "COVERLOGO", "COVER_INFO.COVERLOGO", "COVER_INFO.COVERLOGO");
          if(!imgflag){
              return;
          }
          
          //영문이미지
          await this.checkimgupload(this.$t('pagesetinfo_col37'), "COVERLOGO", "COVER_INFO.COVERLOGO_ENG", "COVER_INFO.COVERLOGO_ENG");
          

            this.progress_dialog = true;
            this.$http.post(this.$host+'/api/PageCoverInfoUpdate',{
                  ADMIN_IDX: this.$session.get("ADMIN_IDX")
                , COM_IDX: this.SEARCH_COM_IDX
                , EVENT_IDX: this.SEARCH_EVENT_IDX
                , COVER_INFO: JSON.stringify(this.editedItem.COVER_INFO)
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then(async(result)=>{

                this.progress_dialog = false;
                
                if(result.data.resultCode == 0){

                    //토큰 저장
                    if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                        this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                    }
                    if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                        this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                    }
                    this.$alert(this.$t('common_edit_msg')).then(()=>{
                        //this.loadpage();
                    });

                }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                }else{
                    this.$alert(this.$t('deviceadminbg_msg8'));
                }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
                this.progress_dialog = false;
                this.$alert(this.$t("common_insert_fail"));
            });

        },              
  
        //검색조건 업체 설정
        eventsearchcb(val1){
          if(val1.NAME.length > 0){
            this.SEARCH_EVENT_NAME = val1.NAME;
            this.SEARCH_EVENT_IDX  = val1.IDX;
            this.$session.set("EVENT_IDX", val1.IDX);
            this.$session.set("EVENT_NAME",val1.NAME);
          }else{
            //일단 업체 선택이 취소되면 리스트를 초기화 시켜야한다.
            
            this.SEARCH_EVENT_NAME = "";
            this.SEARCH_EVENT_IDX  = null;
            this.$session.set("EVENT_IDX", null);
            this.$session.set("EVENT_NAME", "");
          }
          this.editedItem = {};
          this.loadpage();
  
        },      
  
  
        //검색조건 업체 설정
        comsearchcb(val1){
          if(val1.NAME.length > 0){
            this.SEARCH_COM_NAME = val1.NAME;
            this.SEARCH_COM_IDX  = val1.IDX;
          }else{
            this.SEARCH_COM_NAME = '';
            this.SEARCH_COM_IDX  = null;
          }
          this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
          this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          
          this.editedItem = {};
        },
        
        // eslint-disable-next-line no-unused-vars
        comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          
          this.editedItem = {};
  
        },
  
  
        
  
      },
    
  }
  </script>
  
  <!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
  <style scoped>
  
     
  </style>